<div class="container">
  <div class="desktop">
    @if (rows$ | async; as data) {
      <p-table
        #tbl
        [value]="data"
        rowGroupMode="rowspan"
        groupRowsBy="fpcCode"
        sortMode="single"
        sortField="fpcCode"
        dataKey="fpcCode"
        [paginator]="true"
        [rows]="rowsPerPage"
        [rowsPerPageOptions]="[10,15,25,50]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [tableStyle]="{ 'min-width': '70rem' }"
      >
        <ng-template pTemplate="caption">
          <div class="flex justify-content-end">
            <p-iconfield iconPosition="left">
              <p-inputicon><i class="pi pi-search"></i></p-inputicon>
              <input pInputText #q (input)="onGlobalFilter(q.value)" placeholder="Search keyword" />
            </p-iconfield>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="fpcCode">
              FPC Code <p-sortIcon field="fpcCode" />
            </th>
            <th>Restriction ID</th>
            <th>Restriction Name</th>
            <th>Created Date</th>
            <th>Updated Date</th>
            <th>Valid To</th>
            <th>Responsible</th>
            <th>BAN</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-rowgroup="rowgroup" let-rowspan="rowspan">
          <tr class="clickable-row">
            @if (rowgroup) {
              <td [attr.rowspan]="rowspan" class="fpc-code-cell" (click)="goFpc(row.fpcCode)">
                <strong>{{ row.fpcLabel }}</strong>
                <i class="pi pi-chevron-right open-hint-icon"></i>
              </td>
            }
            <td>{{ row.displayName }}</td>
            <td>{{ row.restrictionName }}</td>
            <td>{{ row.dateCreated | date:'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ row.dateUpdated | date:'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ row.validTo | date:'yyyy-MM-dd' }}</td>
            <td>{{ row.responsible }}</td>
            <td>
              @if (row.banPublicRoad) { Public Road }
              @if (row.banPublicRoad && row.banTestTrack) { , }
              @if (row.banTestTrack) { Test Track }
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>
